
import React, { useState } from "react";
import { 
  TextField, Button, Box, Typography, Stepper, Step, StepLabel, 
  Paper, useMediaQuery, useTheme, CircularProgress, Alert
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { createTables } from "../../services/apiService";

const steps = ["البيانات العامة", "الفروع", "الطاولات", "الخزن", "المطابخ"];

const TablesSetup = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // ✅ دعم الهواتف المحمولة
  const isTablet = useMediaQuery(theme.breakpoints.down("md")); // ✅ دعم الأجهزة اللوحية

  const [tableCount, setTableCount] = useState("25");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCreateTables = async () => {
    const count = parseInt(tableCount, 10);
    if (isNaN(count) || count < 1 || count > 999) {
      setError("❌ يجب إدخال عدد صحيح من 1 إلى 999 للطاولات.");
      setSuccessMessage("");
      return;
    }

    try {
      setLoading(true);
      const response = await createTables(count);
      setSuccessMessage(response.message || "✅ تم إنشاء الطاولات بنجاح!");
      setError(null);

      setTimeout(() => navigate('/setup/storages'), 2000);
    } catch (err) {
      setError(err.message);
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
      <Paper elevation={4} sx={{ maxWidth: 600, width: "100%", p: 4, borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }}>
        
        {/* ✅ تحسين `Stepper` ليكون متجاوبًا */}
        <Stepper activeStep={2} alternativeLabel={!isSmallScreen} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{!isTablet ? label : null}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Typography variant={isSmallScreen ? "h6" : "h5"} sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}>
          إعداد الطاولات
        </Typography>

        {/* ✅ إدخال عدد الطاولات */}
        <TextField
          label="عدد الطاولات"
          type="number"
          fullWidth
          inputProps={{ min: 1, max: 999 }}
          value={tableCount}
          onChange={(e) => setTableCount(e.target.value)}
          sx={{ mb: 2 }}
        />

        {/* ✅ تحسين ترتيب الأزرار لتكون متجاوبة */}
        <Box sx={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", gap: 2, justifyContent: "center", mt: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleCreateTables} 
            disabled={loading} 
            fullWidth={isSmallScreen}
          >
            {loading ? <CircularProgress size={20} /> : "التالي"}
          </Button>
        </Box>

        {/* ✅ تحسين رسائل التنبيه */}
        {successMessage && (
          <Alert severity="success" sx={{ mt: 2, textAlign: "center" }}>
            {successMessage}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2, textAlign: "center" }}>
            ❌ {error}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default TablesSetup;
